module.exports = __webpack_public_path__ + "img/nametkin-tower.2d4e2614.png";